export default {
  getAllClubs (state, getters, rootState) {
    return state.allClubs
  },
  getSelectedClub (state) {
    return state.selectedClub
  }
}



// WEBPACK FOOTER //
// ./src/store/clubs/clubs.getters.js